export const painPoints = [
  {
    emoji: '🧭',
    title: "You don't know where to start",
    desc: 'The rehabilitation process looks impossible and you are overwhelmed by where to begin. This method organizes everything: first the assessment, then the acute phase, then progressive strengthening, then return-to-sport.',
  },
  {
    emoji: '🔤',
    title: 'You get stuck with exercise selection (and it all looks the same)',
    desc: 'You learn it here the guided way, so you recognize progression patterns and prescribe with intention. No more confusion between similar exercises and their progressions.',
  },
  {
    emoji: '🧩',
    title: "You know individual exercises but can't build a complete protocol",
    desc: 'You learn the complete phase structure to build protocols that actually make sense and start clients on real recovery from day one.',
  },
  {
    emoji: '💭',
    title: 'You prescribe but forget the progression criteria',
    desc: 'You get concrete assessment checkpoints and advancement guidelines so what you prescribe actually progresses instead of stalling in a week.',
  },
  {
    emoji: '🎯',
    title: 'You manage clients but fear re-injury',
    desc: 'Guessing is dangerous. A clear return-to-sport framework is what keeps athletes safe and confident until they hold their first heavy load again.',
  },
  {
    emoji: '🔁',
    title: 'You started a course and quit after two weeks',
    desc: 'One-off lessons are not progress. A complete 6-volume system with visible milestones is what keeps you going until you manage your first complex injury with confidence.',
  },
];
